
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.716 16.686a.97.97 0 000-1.371l-6.171-6.171a.969.969 0 10-1.371 1.371L29.659 16l-5.485 5.486a.969.969 0 101.371 1.371zM0 16.97h31.031v-1.939H0z"}})])
          )
        }
      }
    